export {};

function installStudioButton() {
  const pages = [...document.querySelectorAll<HTMLElement>(".management-page")];
  const page = pages.find((item) => item.querySelector(".management-heading h1")?.textContent?.trim() === "Activités");
  if (!page || page.querySelector("[data-interactive-activity-studio]")) return;
  const heading = page.querySelector<HTMLElement>(".management-heading");
  if (!heading) return;
  const primary = heading.querySelector<HTMLButtonElement>("button.primary");
  if (!primary) return;

  const actions = document.createElement("div");
  actions.className = "interactive-activity-heading-actions";
  const link = document.createElement("a");
  link.href = "/activity-studio";
  link.className = "secondary";
  link.dataset.interactiveActivityStudio = "true";
  link.textContent = "Activité interactive / IA";
  primary.replaceWith(actions);
  actions.append(link, primary);
}

const observer = new MutationObserver(installStudioButton);
observer.observe(document.documentElement, { childList: true, subtree: true });
window.setTimeout(installStudioButton, 0);
